import { API_STATES } from "@/helpers";

const state = {
  modulesGetState          : API_STATES.NOT_REQUESTED,
  modulesGetError          : null,
  modules                  : [],
  moduleCreateError        : null,
  moduleCreateState        : API_STATES.NOT_REQUESTED,
  companyModuleUpdateState : API_STATES.NOT_REQUESTED,
  companyModuleUpdateError : null,
  moduleStoreCreateState   : API_STATES.NOT_REQUESTED,
  moduleStoreCreateError   : null,
  moduleStoreDeleteState   : API_STATES.NOT_REQUESTED,
  moduleStoreDeleteError   : null,
  module                   : []
};

export default state;